
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Header from './Components/Header';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import About from './Pages/About';
import Hotels from "./Pages/Hotels";
import Contact from "./Pages/Contact";
import RajgirResidency from "./Pages/RajgirResidency";
import VaishaliResidency from "./Pages/VaishaliResidency";
import SravastiResidency from "./Pages/SravastiResidency";
import BodhgayaResidency from "./Pages/BodhgayaResidency";
import BookNow from "./Pages/BookNow";
import Siddharthainternational from "./Pages/Siddharthainternational";
import ScrollToTop from "./Pages/ScrollToTop";
import Events from "./Pages/Events";
import Demotest from "./Pages/Demotest";

function App() {
  return (
    <div>
      <Header />
<ScrollToTop />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/about-us" component={About} />
        <Route path="/hotels" component={Hotels} />
        <Route path="/siddharthainternational" component={Siddharthainternational} />
        <Route path="/contact" component={Contact} />
        <Route path="/Rajgir-Residency" component={RajgirResidency} />
        <Route path="/Vaishali-Residency" component={VaishaliResidency} />
        <Route path="/Sravasti-Residency" component={SravastiResidency} />
        <Route path="/Bodhgaya-Residency" component={BodhgayaResidency} />
        <Route path="/events" component={Events} />
        <Route path="/contact-us" component={BookNow} />
        <Route path="/demo-page" component={Demotest} />        
      </Switch>
      
      <Footer />
    </div>
  );
}

export default App;